/* eslint-disable no-unused-vars */
import store from "@store";
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import { addProductLogandTxt } from "./gpt_addin_utils";
import { findMaxLevel } from "./gpt_onepage_general";
import MarkdownIt from 'markdown-it';

import {
  add_slide_title,
  add_slide_section_header,
  add_slide_title_content,
  add_slide_title_image,
  add_slide_title_content_image,
  add_slide_ending
} from "./gpt_slides";

let contentObjArr = []

export async function add_all_slides(generateContent) {
  let invalidLinkRegex = /\[[^\]]*\]\s*\((?:[^)]*(?:如有|XX|待填写|占位符|示例)[^)]*)\)/g
  const mtp = require("markdown-tree-parser");
  const cleaned = generateContent.replace(invalidLinkRegex, '');
  let treeOutput = mtp(cleaned);
  let treeContent = treeOutput.ast;

  const markdownItAST = require("markdown-it-ast");
  const md = new MarkdownIt();
  const tokens = md.parse(generateContent, {});
  const ast = markdownItAST.makeAST(tokens);
  // const jsonOutput = JSON.stringify(ast, null, 2);
  // console.log('generateContent', generateContent); 
  // console.log("AllJsonOutput", jsonOutput);

  // publish( gptPubIds.pubId_Local_Gpt_ProcessingText, i18n.t("ppt_addin.process.text_ppt_generating_content_parsing")); 
  let slidesData = new Array();
  // for (let i = 0; i < treeContent.length; i++) {
  //   let nodeData = treeContent[i];
  //   if (nodeData.values.length > 0) {
  //     let nodeText = nodeData.values[0].value;
  //     let nextNode = null;
  //     if (i + 1 < treeContent.length - 1) {
  //       nextNode = treeContent[i + 1];
  //     } else {
  //       nextNode = nodeData
  //       nextNode.name = ''
  //     }
  //     /** 
  //      * 0.first page: current heading & next heading & index == 0 || current heading & next not heading and value.length ==0
  //      * 1.section header: current heading & heading but index != 0
  //      * 2.title content: heading & next not heading & value.length > 0
  //      */
  //     if (nodeData.name === 'heading') {
  //       if (nextNode.name === 'heading') {
  //         if (i === 0) {
  //           addSlideData(slidesData, nodeText, '', 'Title Slide')
  //         } else {
  //           addSlideData(slidesData, nodeText, '', 'Section Header')
  //         }
  //       } else {
  //         if (nextNode.values.length > 0) {
  //           let ret = parseParagraphContentStartWithNodeIndex(i, treeContent);
  //           i = ret.endIndex;
  //           addSlideData(slidesData, nodeText, ret.content, 'Title and Content')
  //         } else {
  //           addSlideData(slidesData, nodeText, '', 'Title Slide')
  //         }
  //       }
  //     } else {
  //       let ret = parseParagraphContentStartWithNodeIndex(i, treeContent);
  //       i = ret.endIndex;
  //       addSlideData(slidesData, nodeText, ret.content, 'Title and Content')
  //     }
  //   }
  // }
  for (let i = 0; i < ast.length; i++) {
    let nodeData = ast[i];
    if (astToText(nodeData, 0).length > 0) {
      contentObjArr = []
      let nodeText = astToText(nodeData, 0);
      let nextNode = null;
      let nodeType = nodeData.type || nodeData.nodeType;
      let nextNodeType = '';
      if (i + 1 < ast.length - 1) {
        nextNode = ast[i + 1];
        nextNodeType = nextNode.type || nextNode.nodeType
      } else {
        nextNode = nodeData
        nextNodeType = ''
      }
      //  length = 7
      //  0:heading 1:heading 2:bulllist 3:heading  4:heading 5:bulllist 6:hr
      /** 
       * 0.first page: current heading & next heading & index == 0 || current heading & next not heading and value.length ==0
       * 1.section header: current heading & heading but index != 0
       * 2.title content: heading & next not heading & value.length > 0
       */
      if (nodeType === 'heading') {
        if (nextNodeType === 'heading') {
          if (i === 0) {
            addSlideData(slidesData, nodeText, '', 'Title Slide')
          } else {
            addSlideData(slidesData, nodeText, '', 'Section Header')
          }
        } else {
          if (astToText(nextNode, 0).length > 0) {
            let ret = parseParagraphContentStartWithNodeIndex(i, ast);
            i = ret.endIndex;
            addSlideData(slidesData, nodeText, ret.content, 'Title and Content')
          } else {
            addSlideData(slidesData, nodeText, '', 'Title Slide')
          }
        }
      } else {
        let ret = parseParagraphContentStartWithNodeIndex(i, ast);
        i = ret.endIndex;
        addSlideData(slidesData, nodeText, ret.content, 'Title and Content')
      }
    }
  }

  let generatedPagesCount = 1;
  /** Refactor markdown data into slide data. */
  for (let i = 0; i < slidesData.length; i++) {
    /** unused logic local mesg for user understand current task des */
    // slidesData.length + 1， cause the end page is thanks page, so the total pages is slidesData.length + 1
    publishProcess(generatedPagesCount, slidesData.length + 1);

    let slideData = slidesData[i];
    /** Default type: text only */ 
    let taskOptions = "ppt_option_menu_textonly";
    switch (taskOptions) {
      case "ppt_option_menu_textonly": {
        if (slideData.title.length > 0) {
          if (slideData.content.length > 0) {
            /** title content page */
            await add_slide_title_content(slideData);
            await addProductLogandTxt()
          } else {
            switch (slideData.layoutType) {
              case 'Title Slide':
                /** title page, first page */
                await add_slide_title(slideData);
                await addProductLogandTxt()
                break;
              case 'Section Header':
                /** section page */
                await add_slide_section_header(slideData);
                await addProductLogandTxt()
                break;
              default:
                break;
            }
          }
        }
        break;
      }
      case "ppt_option_menu_text_oneimage": {
        if (slideData.title.length > 0) {
          if (slideData.content.length > 0) {
            if (generatedPagesCount === 1) {
              await add_slide_title_content_image(slideData);
            } else {
              await add_slide_title_content(slideData);
            }
          } else {
            if (generatedPagesCount === 1) {
              await add_slide_title_image(slideData);
            } else {
              if (slideData.layoutType == "Title Slide") {
                await add_slide_title(slideData);
              } else if (slideData.layoutType == "Section Header") {
                await add_slide_section_header(slideData);
              }
            }
          }
        }

        break;
      }
      case "ppt_option_menu_text_allimages": {
        if (slideData.title.length > 0) {
          if (slideData.content.length > 0) {
            await add_slide_title_content_image(slideData);
          } else {
            await add_slide_title_image(slideData);
          }
        }
        break;
      }
    }
    generatedPagesCount++;
  }
  await add_slide_ending()
  
  store.set("gpt/currentSlideId", null);
  store.set("gpt/currentSlideIndex", null);

  // 生成完毕，显示生成页数
  let processtingText = i18n.t("ppt_addin.process.text_ppt_generating_total");
  processtingText = processtingText.replace(
    /\{0\}/g,
    generatedPagesCount + ""
  );
  publish(gptPubIds.pubId_Local_Gpt_ProcessingText, {totalCount: generatedPagesCount, currentIndex: generatedPagesCount, txt: processtingText});
  publish(gptPubIds.pubId_Local_Addin_SystemLog, processtingText);
}

function parseParagraphContentStartWithNodeIndex(startIndex, treeContent) {
  let content = "";
  let endIndex = startIndex;
  // 当前节点是标题且下个节点不是标题，此时，当前节点内容作为标题（在这个方法调用的地方已经做了处理），那么只需从下个节点开始判断，
  // 也就是这个标题下的第一个内容开始，非标题的内容会持续到哪一个节点，因此，直接到内容结束或者遇到下一个【标题】节点为止
  // for (let j = startIndex + 1; j < treeContent.length; ) {
  //   let contentNode = treeContent[j];
  //   if (contentNode.name === "heading") {
  //     endIndex = j - 1;
  //     break;
  //   } else {
  //     endIndex = j
  //     j++;
  //     if (contentNode.values.length > 0) {
  //       for (let index = 0; index < contentNode.values.length; index++) {
  //         content += contentNode.values[index].value;
  //       }
  //       if (j < treeContent.length) {
  //         // 如果下一个节点还不是标题或循环结束，就加个换行，再继续循环增加内容
  //         let nextNode = treeContent[j];
  //         if (nextNode.name !== "heading") {
  //           content += "\r";
  //         }
  //       }
  //     }
  //   }
  // }
  for (let j = startIndex + 1; j < treeContent.length; ) {
    let contentNode = treeContent[j];
    let nodeType = contentNode.type || contentNode.nodeType;
    if (nodeType === "heading") {
      endIndex = j - 1;
      break;
    } else {
      endIndex = j
      j++;
      if (astToText(contentNode, 0).length > 0) {
        content += astToText(contentNode, 0);
        if (j < treeContent.length) {
          // 如果下一个节点还不是标题或循环结束，就加个换行，再继续循环增加内容
          let nextNode = treeContent[j];
          let nextNodeType = nextNode.type || nextNode.nodeType;
          if (nextNodeType !== "heading" && astToText(nextNode, 0).length > 0) {
            content += "\r";
          }
        }
      }
    }
  }
  return { endIndex, content };
}

function addSlideData(slideData, title, content, typeName) {
  publishGenerateProcess(slideData.length)
  slideData.push({
    title: title.replace(/\n$/, ''),
    layoutType: typeName,
    content: content.replace(/\n\s*\n/g, '\n').replace(/\n$/, ''),
    imageUrl: "",
    hasMaxLevel: findMaxLevel(contentObjArr) || 0,
  });
}

function astToText(node, level = 0) {
  let result = '';
  const indent = '  '.repeat(level);
  let nodeType = node.type || node.nodeType;
  let contentObj = {
    level: level,
    nodeType: nodeType,
    text: '',
  }

  switch (nodeType) {
    case 'root':
      node.children.forEach(child => {
        result += astToText(child, level);
      });
      break;
    case 'heading':
      result += `${indent}${node.children.map(child => child.content).join('')}\n`;
      break;
    case 'paragraph':
      result += `${indent}${node.children.map(child => astToText(child, level)).join('')}\n`;
      break;
    case 'text':
      result += node.content;
      break;
    case 'strong':
    case 'link':
    case 'inline':
      result += node.children.map(child => astToText(child, level)).join('');
      break;
    case 'bullet_list':
    case 'ordered_list':
      node.children.forEach(child => {
        result += astToText(child, level);
      });
      break;
    case 'list':
      node.children.forEach(child => {
        result += astToText(child, level);
      });
      break;
    case 'list_item':
      result += `${indent}${node.children.map(child => astToText(child, level + 1)).join('')}\n`;
      break;
    case 'strong_open':
    case 'strong_close':
    case 'hardbreak':
    case 'hr':
    case 'softbreak':
      break;
    default:
      console.log('Unknown node type:', nodeType);
  }
  contentObj.text = result.trim();
  if (nodeType === 'text' || nodeType === 'heading') {
    contentObjArr.push(contentObj);
  }
  return result;
}

function publishGenerateProcess(pageNumber) {
  // 更新提示
  let processtingText = i18n.t("ppt_addin.process.text_ppt_generating_text");
  processtingText = processtingText.replace(/\{0\}/g, pageNumber + "");
  publish(gptPubIds.pubId_Local_Gpt_ProcessingText, {totalCount: 0, currentIndex: pageNumber, txt: processtingText});
}

function publishProcess(pageNumber, slideLength) {
  // 更新提示
  let processtingText = i18n.t("ppt_addin.process.text_ppt_make_slide");
  processtingText = processtingText.replace(/\{0\}/g, pageNumber + "").replace(/\{1\}/g, slideLength + "");
  if (pageNumber != slideLength) {
    publish(gptPubIds.pubId_Local_Gpt_ProcessingText, {totalCount: slideLength, currentIndex: pageNumber, txt: processtingText});
  }
}
